import React from "react";
import { Route, Switch, useParams } from "react-router-dom";
import { Skeleton } from "antd";

import PersonalDetails from "./components/PersonalDetails/PersonalDetails";
import Reporting from "./components/Reporting/Reporting";
import Summary from "./components/Summary/Summary";
import UserAttachment from "./components/UserAttachment/UserAttachment";

import {
  buildPPIDetailsUri,
  buildPPISummaryUri,
  buildPPIReportingUri,
  buildPPIUserAttachmentUri,
} from "utils/routes";

const Personal = ({
  isLoading,
  summaryInfo,
  personalDetails,
  reportingDetails,
  cashFlowDetails,
  estatePlanningDetails,
  investmentPortfolio,
  actionPlans,
  futureReviews,
  contactList,
}) => {
  const { id: adviseeId } = useParams();
  return (
    <Switch>
      <Route path={buildPPISummaryUri(adviseeId)}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <Summary
            personalInfo={summaryInfo.personalInfo}
            financialInfo={summaryInfo.financialInfo}
            insurancesInfo={summaryInfo.insuranceSummary}
          />
        )}
      </Route>
      <Route path={buildPPIDetailsUri(adviseeId)}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <PersonalDetails personalInfo={personalDetails} />
        )}
      </Route>
      <Route path={buildPPIReportingUri(adviseeId)}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <Reporting
            personalInfo={summaryInfo.personalInfo}
            reportingDetails={reportingDetails}
            financialInfo={summaryInfo.financialInfo}
            insurancesInfo={summaryInfo.insuranceSummary}
            personalDetails={personalDetails}
            cashFlowDetails={cashFlowDetails}
            estatePlanningDetails={estatePlanningDetails}
            investmentPortfolio={investmentPortfolio}
            actionPlans={actionPlans}
            futureReviews={futureReviews}
            contactList={contactList}
          />
        )}
      </Route>
      <Route path={buildPPIUserAttachmentUri(adviseeId)}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <UserAttachment personalInfo={personalDetails} />
        )}
      </Route>
    </Switch>
  );
};

Personal.defaultProps = {
  isLoading: true,
  summaryInfo: {},
  personalDetails: {},
  reportingDetails: {},
  cashFlowDetails: {},
  estatePlanningDetails: {},
  investmentPortfolio: {},
  actionPlans: [],
  futureReviews: [],
};

export default Personal;
